import { useState, useEffect, useRef } from "react";
import { Search, Check, Building2 } from "lucide-react";

export function CustomerCombobox({ value, customers, selectedId, onPick, onType, testid }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value || "");
  const boxRef = useRef(null);
  const focusedRef = useRef(false);

  // Keep the shown text in sync with the form unless the user is actively typing here.
  useEffect(() => {
    if (focusedRef.current) return;
    setQuery(value || "");
  }, [value]);

  useEffect(() => {
    const onDoc = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const q = query.trim().toLowerCase();
  const results = (customers || [])
    .filter((c) => !q || [c.company_name, c.customer_code, c.contact_name].some((f) => String(f || "").toLowerCase().includes(q)))
    .slice(0, 50);

  const choose = (c) => {
    setQuery(c.company_name);
    onPick(c);
    setOpen(false);
  };

  return (
    <div ref={boxRef} className="relative">
      <div className="relative">
        <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          data-testid={testid}
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); onType(e.target.value); }}
          onFocus={() => { focusedRef.current = true; setOpen(true); }}
          onBlur={() => { focusedRef.current = false; }}
          autoComplete="off"
          placeholder="Firma adı ara veya yaz..."
          className="w-full rounded-xl border border-border bg-white py-3 pl-10 pr-9 text-base outline-none transition-colors focus:border-primary"
        />
        {selectedId && <Check className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-emerald-500" />}
      </div>
      {open && (
        <div data-testid={`${testid}-dropdown`} className="absolute z-40 mt-1 max-h-64 w-full overflow-auto rounded-xl border border-border bg-white shadow-xl">
          {results.length === 0 && (
            <div className="px-3 py-3 text-sm text-muted-foreground">Kayıtlı müşteri yok · elle girebilirsiniz</div>
          )}
          {results.map((c) => (
            <button
              key={c.id}
              type="button"
              data-testid={`customer-option-${c.id}`}
              onClick={() => choose(c)}
              className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm transition-colors hover:bg-secondary"
            >
              <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
              <span className="truncate font-semibold">{c.company_name}</span>
              {c.customer_code && <span className="font-mono text-xs text-primary">{c.customer_code}</span>}
              {c.phone && <span className="ml-auto shrink-0 text-xs text-muted-foreground">{c.phone}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
